var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_04",
    "data-name": 4,
    transform: "translate(-499 -56.076)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2689",
    "data-name": "Rectangle 2689",
    width: 112,
    height: 112,
    rx: 21,
    transform: "translate(499 56.076)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "footprint",
    transform: "translate(508.723 82.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12628",
    "data-name": "Path 12628",
    d: "M356.155,17.939l-.421-6.273a.662.662,0,0,1,.829-.685l4.071,1.07a.662.662,0,0,1,.374,1.021l-3.65,5.2A.662.662,0,0,1,356.155,17.939Z",
    transform: "translate(-297.824 -9.683)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12629",
    "data-name": "Path 12629",
    d: "M363.407,18.711l-3.65,5.2a.662.662,0,0,1-1.2-.337l-.107-1.6L361.7,17.34l1.331.35A.661.661,0,0,1,363.407,18.711Z",
    transform: "translate(-300.222 -15.322)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12630",
    "data-name": "Path 12630",
    d: "M402.26,38.258l6.7-7.3a.662.662,0,0,1,1.089.17l2.557,5.536a.662.662,0,0,1-.477.928l-9.258,1.768A.662.662,0,0,1,402.26,38.258Z",
    transform: "translate(-338.778 -27.161)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12631",
    "data-name": "Path 12631",
    d: "M412.133,70.979l-9.258,1.768a.662.662,0,0,1-.612-1.1l1.4-1.525,8.1-1.547a.64.64,0,0,0,.147-.047l.7,1.52A.662.662,0,0,1,412.133,70.979Z",
    transform: "translate(-338.781 -60.552)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12632",
    "data-name": "Path 12632",
    d: "M77.623,293.483l10.656-2.607a.664.664,0,0,1,.81.525l.982,6.562a5.681,5.681,0,0,1-10.915,3l-2-6.6A.663.663,0,0,1,77.623,293.483Z",
    transform: "translate(-51.648 -256.992)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10560",
    "data-name": "Group 10560",
    transform: "translate(18.663 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12633",
    "data-name": "Path 12633",
    d: "M35.591,29.238c-2.022.494-8.873,2.384-10.91,2.947a.663.663,0,0,1-.793-.395c-3.066-7.747-5.616-11.621-5.176-18.066.38-5.569,3.024-11.184,8.56-13.244C31.731-1.18,35.45,1.69,37,5.805c1.991,5.3.227,10.749-.577,16.084a31.944,31.944,0,0,0-.389,4.42c0,.239.04,1.513.066,2.262a.661.661,0,0,1-.5.666Z",
    transform: "translate(-18.663 -0.001)",
    fill: "#ff9100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10561",
    "data-name": "Group 10561",
    transform: "translate(42.655 12.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12634",
    "data-name": "Path 12634",
    d: "M249.807,133.618c1.981.64,8.677,3.02,10.667,3.729a.663.663,0,0,0,.819-.336c3.619-7.5,6.443-11.184,6.471-17.644.024-5.494-2.346-11.437-7.578-13.829-4.326-1.978-8.244.616-10.083,4.608-2.369,5.141-1.005,10.7-.589,16.084a31.941,31.941,0,0,1,.068,4.437c-.014.239-.149,1.506-.23,2.251A.661.661,0,0,0,249.807,133.618Z",
    transform: "translate(-245.948 -104.86)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12635",
    "data-name": "Path 12635",
    d: "M237.646,394.147l-10.44-3.372a.664.664,0,0,0-.846.465l-1.455,6.474a5.681,5.681,0,0,0,10.67,3.779l2.471-6.439A.663.663,0,0,0,237.646,394.147Z",
    transform: "translate(-224.722 -357.457)",
    fill: "#ff9100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10564",
    "data-name": "Group 10564",
    transform: "translate(26.708 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10562",
    "data-name": "Group 10562",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12636",
    "data-name": "Path 12636",
    d: "M97.079,26.309c0,.238.04,1.513.066,2.262a.661.661,0,0,1-.5.666c-.464.113-1.18.3-2.034.526a.661.661,0,0,0,.246-.538c-.026-.749-.07-2.022-.066-2.262a31.83,31.83,0,0,1,.388-4.419c.805-5.335,2.568-10.785.579-16.084-1.342-3.57-4.319-6.2-8-5.754.185-.08.374-.156.565-.228C92.781-1.181,96.5,1.689,98.046,5.8c1.99,5.3.228,10.749-.577,16.084A31.87,31.87,0,0,0,97.079,26.309Z",
    transform: "translate(-87.758 0.001)",
    fill: "#e09f4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12637",
    "data-name": "Path 12637",
    d: "M142.851,304.475a5.69,5.69,0,0,1-1.332.192,5.68,5.68,0,0,0,3.164-6.162l-.982-6.561a.665.665,0,0,0-.658-.545l2.141-.524a.663.663,0,0,1,.81.525l.982,6.563A5.681,5.681,0,0,1,142.851,304.475Z",
    transform: "translate(-135.26 -256.991)",
    fill: "#e09f4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10563",
    "data-name": "Group 10563",
    transform: "translate(18.849 12.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12638",
    "data-name": "Path 12638",
    d: "M338.575,119.805c-.029,6.461-2.852,10.14-6.471,17.644a.662.662,0,0,1-.819.337l-1.925-.685a.665.665,0,0,0,.452-.358c3.619-7.5,6.443-11.184,6.47-17.644.024-5.429-2.291-11.3-7.4-13.743a7.372,7.372,0,0,1,2.111.621C336.228,108.368,338.6,114.311,338.575,119.805Z",
    transform: "translate(-319.66 -105.355)",
    fill: "#e09f4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12639",
    "data-name": "Path 12639",
    d: "M260.07,415.522l-2.471,6.439a5.679,5.679,0,0,1-7.029,3.016,5.587,5.587,0,0,1-.922-.416q.243.022.485.022a5.682,5.682,0,0,0,5.172-3.329l2.471-6.439a.664.664,0,0,0-.4-.907l2.294.708A.663.663,0,0,1,260.07,415.522Z",
    transform: "translate(-249.647 -377.983)",
    fill: "#e09f4c"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalking);
export default __webpack_public_path__ + "static/media/walking.7228c11af25efd1b908ec557052e28a2.svg";
export { ForwardRef as ReactComponent };